Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PinterestBoard = void 0;

var _react = _interopRequireDefault(require("react"));

var _generalObserver = require("../general-observer");

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var PinterestBoard = function PinterestBoard(_ref) {
  var pinterestLink = _ref.pinterestLink,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 400 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 250 : _ref$height,
      _ref$imageWidth = _ref.imageWidth,
      imageWidth = _ref$imageWidth === void 0 ? 80 : _ref$imageWidth,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'board' : _ref$variant;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handlePinterestBuild)();
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "pinterest-board pinterest-board-mdx-embed",
    "data-pin-do": "embed".concat(variant.charAt(0).toUpperCase()).concat(variant.slice(1)),
    "data-pin-board-width": width,
    "data-pin-scale-height": height,
    "data-pin-scale-width": imageWidth,
    href: "https://www.pinterest.com/".concat(pinterestLink)
  }));
};

exports.PinterestBoard = PinterestBoard;